'use client';

import {
  Form,
  FormField,
  FormItem,
  FormMessage,
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
  LoadingSpinner,
} from '@shared/ui';
import { motion } from 'framer-motion';
import { useOtpInput } from '../model';

interface OtpInputProps {
  phoneNumber?: string;
  innerText?: string;
  className?: string;
}

export const OtpInput: React.FC<OtpInputProps> = ({ phoneNumber, innerText, className = '' }) => {
  const { form, inputRef, isPending, length, handleChange } = useOtpInput();

  const inputAnimate = {
    normal: {
      x: 0,
    },
    shake: {
      x: [-5, 5, -5, 5, 0],
      transition: {
        duration: 0.2,
      },
    },
  };

  return (
    <Form {...form}>
      <form>
        <div className={`text-right text-text h3 !font-normal ${className}`}>
          <div className='flex flex-col items-center justify-center gap-3 p-5'>
            <p
              data-testid='contactinfo-phone-otp-hint'
              className='body-12-regular text-text text-center'
            >
              {innerText || 'کد تاییدی که از طریق پیامک دریافت کرده‌اید را وارد کنید.'}
              {phoneNumber && (
                <>
                  <br />
                  <b className='body-14-regular pt-1 block' dir='ltr'>{phoneNumber}</b>
                </>
              )}
            </p>

            <FormField
              control={form.control}
              name='otp'
              render={({ field, fieldState }) => (
                <FormItem>
                  <div className='flex justify-center'>
                    <motion.div
                      data-testid='contactinfo-phone-otp-input'
                      variants={inputAnimate}
                      animate={fieldState.error ? 'shake' : 'normal'}
                      dir='ltr'
                    >
                      <InputOTP
                        {...field}
                        ref={inputRef}
                        maxLength={length}
                        value={field.value}
                        onChange={handleChange}
                        disabled={isPending}
                        autoFocus
                        pattern='^[0-9\u06F0-\u06F9]+$'
                      >
                        <InputOTPGroup>
                          {Array.from({ length }).map((_, index) => (
                            <InputOTPSlot
                              key={index}
                              index={index}
                              className={fieldState.error ? 'border-red-1' : ''}
                            />
                          ))}
                        </InputOTPGroup>
                      </InputOTP>
                    </motion.div>
                  </div>
                  {isPending && <LoadingSpinner className='mx-auto text-pics scale-[0.6]' />}

                  <FormMessage
                    data-testid='contactinfo-phone-otp-error'
                    className='body-12-regular text-red-1 text-center !mt-2'
                  />
                </FormItem>
              )}
            />
          </div>
        </div>
      </form>
    </Form>
  );
};
